import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Arbitrator from '../../components/Arbitrator';
import axios from 'axios';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ChooseArbitratorDialogInCaseInformation from './ChooseArbitratorDialogInCaseInformation';
import ChooseArbitratorDialogRespondent from './ChooseArbitratorDialogRespondent';
import { getCaseIdFromUrl } from '../../utils/caseIdFromUrl';


const styles = theme => ({
    root: {
        display: 'flex',
        marginTop:'20px'
    },
    formControl: {
        // margin: theme.spacing.unit * 3,
    },
    group:{
        justifyContent:'center',
        marginTop:'20px'
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        // margin: theme.spacing.unit * 3,
    },
});

class ChooseArbitratorInCaseInformation extends Component {

    state = {
      value: '',
      open: false,
      open_: true,
      uniqueId: localStorage.getItem('token'),
      preRespondentUniqueId:this.props.claimantUniqueId,
      preRespondentArbitratorName:this.props.claimantArbitratorName
    };

    componentDidMount(){
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getCaseInfo`;
        let payload = {
            caseId: this.props.match.params.id,
        }
        axios.post(url, payload)
        .then((response) => {
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            // this.setState({value: response.data.claimantArbitrator});

        })
        .catch((error) => {
            console.log(error);
        });

        setInterval(()=>{
            // if (this.props.lang == 'en'){
                this.props.getArbitrators(localStorage.getItem('token'));
            // }
            // else{
            //     this.props.getArbitratorsChi(localStorage.getItem('token'));
            // }
        },1000)

        // this.props.getArbitrators(localStorage.getItem('token'))
    }

    handleChange = event => {
        this.setState({
            value: event.target.value,
             open: true,
        });
        //this.props.setArbitrators(this.props.match.params.id, event.target.value, this.props.handleComplete);
    }

    setArbitrators = () => {
        console.log('setArbitrators3')
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        // if(this.props.caseData.claimantUniqueId == this.state.uniqueId){
        //     userType = 'claimant';
        // }
        // else if(this.props.caseData.respondentUniqueId == this.state.uniqueId){
        //     userType = 'respondent';
        // }

        this.props.setArbitrators(getCaseIdFromUrl(), false, this.state.value, userType, this.props.handleComplete);
        this.props.getCaseInfo(getCaseIdFromUrl(), localStorage.getItem('token'));
    }

    toggleOpen = () => {
        this.setState( (prevState) => ({
            open: !prevState.open,
        }) );
      }

    toggleOpen_ = () => {
        this.setState( (prevState) => ({
            open_: !prevState.open_,
        }) );
    }

    unSelect = () =>{
        this.setState({
            value: '',
        });
    }

    render(){
        const { classes, isLoading, arbitrators } = this.props;
        
        if(isLoading){
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }

        /*if(this.state.open){
            return (<ChooseArbitratorDialog open={this.state.open} toggleOpen={this.toggleOpen}/>);
        }*/

        var userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        var lang = localStorage.getItem('language');
        
        var threeDaysLaterTime
        var caseEnterTimestamp = this.props.caseData.claimant_payment && this.props.caseData.claimant_payment.timestamp 
            ? new Date(this.props.caseData.claimant_payment.timestamp) 
            : new Date();
        if (this.props.caseData.response !== undefined){
            threeDaysLaterTime = new Date(this.props.caseData.response.timestamp)
            if(threeDaysLaterTime.getFullYear() <= 2025){
                threeDaysLaterTime.setDate(threeDaysLaterTime.getDate() + 3);
            }
            else{
                threeDaysLaterTime.setDate(threeDaysLaterTime.getDate() + 2);
            }
        }
        
        if (userType == 'respondent'){

            const timeIsUp = threeDaysLaterTime && new Date() >= threeDaysLaterTime;

            return(
                <div className={classes.root}>
                    <FormControl component='fieldset' className={classes.group} >

                        {this.props.caseData.response !== undefined && <Typography style={{textAlign: 'justify', paddingLeft:'100px',paddingRight:'100px'}}>
                            {this.context.t('3DaysDescription')} {caseEnterTimestamp.getFullYear() <= 2025 ? ' 3 ' : ' 2 '} {this.context.t('3DaysDescription2')} {caseEnterTimestamp.getFullYear() <= 2025 ? ' 3 ' : ' 2 '} {this.context.t('3DaysDescription3')} {this.context.t('End Date:')} {' '+threeDaysLaterTime.getDate()+'-'+(threeDaysLaterTime.getMonth()+1)+'-'+threeDaysLaterTime.getFullYear() + ' '+ threeDaysLaterTime.getHours()+':'+threeDaysLaterTime.getMinutes()+':'+threeDaysLaterTime.getSeconds()}
                        </Typography>}

                        {!timeIsUp ? (
                            <Fragment>
                                {this.props.caseData.arbitratorStatus == 'waiting' && 
                                    (this.props.caseData.claimantArbitrator == this.props.caseData.respondentArbitrator) &&
                                <Typography style={{marginTop:'30px',}}>
                                    {this.context.t('Waiting for arbitrator to accept or reject the case.')}
                                </Typography>}

                                <Typography style={{marginTop:'30px',}}>
                                    {this.context.t('Please choose your arbitrator.')}
                                </Typography>
                                <ChooseArbitratorDialogInCaseInformation 
                                    unSelect = {this.unSelect}
                                    arbitrators={arbitrators} 
                                    arbitratorId={this.state.value}
                                    open={this.state.open} 
                                    toggleOpen={this.toggleOpen} 
                                    setArbitrators={this.setArbitrators} 
                                    claimantArbitratorName={this.props.caseData.claimantArbitratorName} 
                                    respondentArbitratorName={this.props.caseData.respondentArbitratorName} 
                                    claimantUniqueId={this.props.claimantUniqueId}
                                    respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />
                                <div style={{width:'50%', margin: '0 auto'}}>
                                    <RadioGroup
                                        row
                                        style={{textAlign:'left', justifyContent:'center'}}
                                        name='chooseArbitrator'
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                    >
                                        {
                                        arbitrators.map((arbitrator, index) => (
                                            <FormControlLabel
                                                key={index}
                                                value={arbitrator.arbitratorId}
                                                label={<Arbitrator 
                                                    firstName={arbitrator.firstname}
                                                    lastName={arbitrator.lastname}
                                                    occupation={arbitrator.occupation}
                                                    jurisdiction={arbitrator.jurisdiction}
                                                    expertise={arbitrator.expertise}
                                                    arbitratorId={arbitrator.arbitratorId}
                                                    firstName_chi={arbitrator.firstname_chi}
                                                    lastName_chi={arbitrator.lastname_chi}
                                                    occupation_chi={arbitrator.occupation_chi}
                                                    jurisdiction_chi={arbitrator.jurisdiction_chi}
                                                    expertise_chi={arbitrator.expertise_chi}
                                                    lang = {lang}
                                                    arbitrator={this.context.t('arbitrator')}
                                                    arbitratorProfile={this.context.t('arbitratorProfile')}
                                                    jurisdictions={ this.context.t('Jurisdiction') }
                                                    occupations={ this.context.t('Occupation') }
                                                />}
                                                control={<Radio style={{display:'none'}}  key={index}
                                                classes={{root: classes.radio, checked: classes.checked}}/>}
                                            />
                                        ))
                                        }
                                    </RadioGroup>
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                {this.props.caseData.arbitratorStatus == 'false' && 
                                <Typography style={{marginTop:'30px', }}>
                                    {this.context.t('Arbitrator')} {this.props.caseData.claimantArbitratorName}{this.context.t('rejected the case.')}
                                </Typography>}

                                {this.props.caseData.arbitratorStatus == 'true' && 
                                <Typography style={{marginTop:'30px', }}>
                                    {this.context.t('Arbitrator')} {this.props.caseData.claimantArbitratorName}{this.context.t('accepted the case.')}
                                </Typography>}
                            </Fragment>
                        )}

                    </FormControl>
                </div>
            )
        }
        else{
            return(
                <div className={classes.root}>
                 <Grid
                    className={classes.group}
                    container
                    alignItems='center'
                    direction='column'
                    justify='center'
                    >

                        {this.props.caseData.response !== undefined && <Typography style={{textAlign: 'justify', paddingLeft:'100px',paddingRight:'100px'}}>
                        {this.context.t('3DaysDescription')} {caseEnterTimestamp.getFullYear() <= 2025 ? ' 3 ' : ' 2 '} {this.context.t('3DaysDescription2')} {caseEnterTimestamp.getFullYear() <= 2025 ? ' 3 ' : ' 2 '} {this.context.t('3DaysDescription3')}  {this.context.t('End Date:')} {' '+threeDaysLaterTime.getDate()+'-'+(threeDaysLaterTime.getMonth()+1)+'-'+threeDaysLaterTime.getFullYear() + ' '+ threeDaysLaterTime.getHours()+':'+threeDaysLaterTime.getMinutes()+':'+threeDaysLaterTime.getSeconds()}
                        </Typography>}

                        {this.props.caseData.arbitratorStatus == 'false' && 
                        <Typography style={{marginTop:'30px', }}>
                            {this.context.t('Arbitrator')} {this.props.caseData.claimantArbitratorName}{this.context.t('rejected the case.')}
                        </Typography>}

                        {this.props.caseData.arbitratorStatus == 'true' && 
                        <Typography style={{marginTop:'30px', }}>
                            {this.context.t('Arbitrator')} {this.props.caseData.claimantArbitratorName}{this.context.t('accepted the case.')}
                        </Typography>}

                        {this.props.caseData.arbitratorStatus == 'waiting' && 
                            (this.props.caseData.claimantArbitrator == this.props.caseData.respondentArbitrator) &&
                        <Typography style={{marginTop:'30px', }}>
                            {this.context.t('Waiting for arbitrator to accept or reject the case.')}
                        </Typography>}
                        <Typography style={{marginTop:'30px', }}>
                            {this.context.t('Please choose your arbitrator.')}
                        </Typography>
                    <ChooseArbitratorDialogInCaseInformation unSelect = {this.unSelect} arbitrators={arbitrators} arbitratorId={this.state.value} open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.caseData.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />
                    
                    <FormControl component='fieldset' className={classes.group}>
                        <ChooseArbitratorDialogInCaseInformation unSelect = {this.unSelect} arbitrators={arbitrators} arbitratorId={this.state.value} open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.caseData.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />
                        <div style={{width:'50%', margin: '0 auto'}}>
                        <RadioGroup
                                row
                                style={{textAlign:'left', justifyContent:'center'}}
                                name='chooseArbitrator'
                                className={classes.group}
                                value={this.state.value}
                                onChange={this.handleChange}
                                >
                                {
                                    arbitrators.map((arbitrator, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={arbitrator.arbitratorId}
                                            label={<Arbitrator 
                                                        firstName={arbitrator.firstname}
                                                        lastName={arbitrator.lastname}
                                                        occupation={arbitrator.occupation}
                                                        jurisdiction={arbitrator.jurisdiction}
                                                        expertise={arbitrator.expertise}
                                                        arbitratorId={arbitrator.arbitratorId}
                                                        firstName_chi={arbitrator.firstname_chi}
                                                        lastName_chi={arbitrator.lastname_chi}
                                                        occupation_chi={arbitrator.occupation_chi}
                                                        jurisdiction_chi={arbitrator.jurisdiction_chi}
                                                        expertise_chi={arbitrator.expertise_chi}
                                                        lang = {lang}
                                                        arbitrator={this.context.t('arbitrator')}
                                                        arbitratorProfile={this.context.t('arbitratorProfile')}
                                                        jurisdictions={ this.context.t('Jurisdiction') }
                                                        occupations={ this.context.t('Occupation') }
                                                    />}
                                            control={<Radio style={{display:'none'}}  key={index}
                                            classes={{root: classes.radio, checked: classes.checked}}/>}
                                        />
                                    ))
                                    // </form>
                                }
                        </RadioGroup>
                        </div>
                    </FormControl>
                </Grid>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.arbitrator.loading,
        arbitrators: state.arbitrator.arbitrators,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimantArbitratorName: state.caseInfo.claimantArbitratorName,
        respondentArbitratorName: state.caseInfo.respondentArbitratorName,
        claimantArbitrator: state.caseInfo.caseData.claimantArbitrator,
        respondentArbitrator: state.caseInfo.caseData.respondentArbitrator,
        lang: state.i18nState.lang,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
        getArbitrators: () => dispatch(actions.arbitrators()),
        getArbitratorsChi: () => dispatch(actions.arbitratorsChi()),
        setArbitrators: (caseId, firstTime, arbitratorId, type, handleComplete) => dispatch(actions.setArbitrators(caseId, firstTime, arbitratorId, type, handleComplete)),
    }
}

ChooseArbitratorInCaseInformation.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChooseArbitratorInCaseInformation)));
